import { initModules } from '../modules';

// Body Margin Top Builder
function setMainContentMarginTop() {
  const mainNav = document.getElementById('main-nav');
  const mainContent = document.querySelector('.site-main-internal-page');

  function updateMarginTop() {
    if (mainNav && mainContent) {
      const mainNavHeight = mainNav.offsetHeight;
      // mainContent.style.marginTop = `${mainNavHeight * 2}px`;
      mainContent.style.marginTop = `${mainNavHeight}px`;
    }
  }

  // Initial margin calculation
  updateMarginTop();

  // Update margin on window resize
  window.addEventListener('resize', updateMarginTop);
}

// Call the function after the DOM is loaded
document.addEventListener('DOMContentLoaded', setMainContentMarginTop);

// -----------------------------------------------------------------------------

const html = document.documentElement;
html.classList.remove('no-js');

// -----------------------------------------------------------------------------

initModules();
